// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type OwnerPaymentGatewayFragment = { __typename?: 'OwnerPaymentGatewayDTO', id: number, description: string | null };

export const OwnerPaymentGatewayFragment = gql`
    fragment OwnerPaymentGateway on OwnerPaymentGatewayDTO {
  id
  description
}
    `;
/* eslint-enable */